export default __webpack_public_path__ + "static/media/flag-start-icon.0f7ce990.svg";